import { Injectable } from '@angular/core';

import { MyHttpClient } from '../../http-client';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';

@Injectable()
export class RoadTaxService {
  server: string = environment.SERVER;
  updateImageUrl = process.env.SERVER + '/api/update/roadTax/roadTaxImage';
  updateVehicleNumberUrl = process.env.SERVER + '/api/update/roadTax/vehicleNumber';
  updateVehicleModelUrl = process.env.SERVER + '/api/update/roadTax/vehicleModel';
  updateRegistrationDateUrl = process.env.SERVER + '/api/update/roadTax/registrationDate';
  getVehiclesListURL = process.env.SERVER + '/api/get/vehicleModel';
  submitRoadTaxUrl = process.env.SERVER + '/api/update/roadTax';
  rotateUrl = process.env.SERVER + '/api/imageRotate';
  deleteAllUrl = process.env.SERVER + '/api/profile/deleteTempFiles';

  constructor(private http: MyHttpClient) { }

  deleteTempFiles() {
    return this.http.get(this.deleteAllUrl)
      .pipe(
        retry(3),
        catchError(this.handleError)
      );
  }

  rotateImage(link, degrees) {
    return this.http.post(this.rotateUrl, {
      link: link,
      degrees: degrees
    }).pipe(catchError(this.handleError));
  }

  updateImage(imageData, url, userId, imageType, view) {
    return this.http.post(this.updateImageUrl, {
      'data': imageData,
      'url': url,
      'userId': userId,
      'mode': 'upload',
      'folder': imageType,
      'view': view
    }).pipe(catchError(this.handleError));
  }

  updateVehicleNumber(id, vehicleNumber) {
    const payload = {
      'userId': id,
      'data': vehicleNumber
    };
    return this.http.post(this.updateVehicleNumberUrl, payload).pipe(catchError(this.handleError));
  }

  getVehiclesList(modeId) {
    return this.http.get(`${this.getVehiclesListURL}?modeId=${modeId}&active=true`).pipe(
      map((res: any) => {
        const vehicles = (res && res.data && Array.isArray(res.data.vehicles)) ? res.data.vehicles
          : (res && Array.isArray(res.items)) ? res.items
          : [];
        return { data: { vehicles } };
      }),
      catchError(this.handleError)
    );
  }

  updateVehicleModel(id, vehicleModel, fleetNumber) {
    const payload = {
      'userId': id,
      'data': vehicleModel
    };
    if (fleetNumber) {
      payload['fleetNumber'] = fleetNumber;
    }
    return this.http.post(this.updateVehicleModelUrl, payload).pipe(catchError(this.handleError));
  }

  updateRegistrationDate(id: string, registrationDate: string, fleetNumber?: string) {
    const payload = {
      userId: id,
      registrationDate: registrationDate,
    };
    if (fleetNumber) {
      payload['fleetNumber'] = fleetNumber;
    }
    return this.http.put(this.updateRegistrationDateUrl, payload).pipe(catchError(this.handleError));
  }

  submitRoadTax(id, roadTaxData, fleetId) {
    const payload = {
      'roadTax': roadTaxData,
      'userId': id
    };
    if (fleetId) {
      payload['fleetId'] = fleetId;
    }
    return this.http.post(this.submitRoadTaxUrl, payload).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    let customError: any;
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      if (typeof error === 'string') {
        customError = {
          error: {
            message: error,
          }
        };
      }
    }
    return throwError(customError || error);
  }
}
